import { Pipe, PipeTransform } from '@angular/core';

import { Duration } from '../../core/configs/dayjs';
import { dayjsDurationFormat } from '../../core/utils/dayjs-duration-format';

@Pipe({
	name: 'dayjsDurationFormat',
})
export class DayjsDurationFormatPipe implements PipeTransform {
	public transform(value: Duration): string {
		if (!value) {
			return '';
		}
		return dayjsDurationFormat(value);
	}
}
